import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Title } from '@angular/platform-browser';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { PageHeaderComponent } from '../../layout/page-header/page-header.component';

export interface CookieTable {
  cookie: string;
  name: string;
  cookieDescription: string;
}

const ELEMENT_DATA: CookieTable[] = [
  {
    cookie: 'Google Analytics', name: '_utma; _utmb; _utmc; _utmz; _ga; _gat_gtag_UA_125882190_2; DoubleClick', cookieDescription:
      // tslint:disable-next-line: max-line-length
      'These cookies are used to collect information about how visitors use our website. We use this information to help us improve our website. These cookies collect information in an anonymous form.' +
      // tslint:disable-next-line: max-line-length
      '<br><br>Find out more about Google Analytics privacy policy <a href="http://www.google.co.uk/intl/en/analytics/privacyoverview.html">here.</a>'
  },
  // tslint:disable-next-line: max-line-length
  { cookie: 'Website', name: '	has_js', cookieDescription: 'This cookie is used to determine if your web browser supports modern web pages. We use it to give you the best possible experience when visiting the site.' },
  { cookie: 'team.bruces.dog', name: 'branch_id', cookieDescription: 'This cookie is used to determine your branch ID' },
  // tslint:disable-next-line: max-line-length
  { cookie: 'Access Token', name: '_bddc_access_token', cookieDescription: 'This cookie is used to provide access to the customer portal' },
  // tslint:disable-next-line: max-line-length
  { cookie: 'Device Id', name: '_bddc_device_id', cookieDescription: 'This cookie is used to identify the device that is using the customer portal' },
  // tslint:disable-next-line: max-line-length
  { cookie: 'Refresh Token', name: '_bddc_refresh_token', cookieDescription: 'This cookie is used to refresh the customer portal when a new access token is issued' },
];

@Component({
    selector: 'app-cookies',
    templateUrl: './cookies.component.html',
    styleUrls: ['./cookies.component.scss'],
    standalone: true,
    imports: [PageHeaderComponent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow]
})
export class CookiesComponent implements OnInit {

  headerImage = '';
  displayedColumns: string[] = ['cookie', 'name', 'what_this_cookie_does'];
  dataSource = ELEMENT_DATA;

  constructor(breakpointObserver: BreakpointObserver, private title: Title) {
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      if (result.matches) {
        this.headerImage = './../../../../../assets/images/backgrounds/settings/privacy_header_mobile.jpg';
      } else {
        this.headerImage = './../../../../../assets/images/backgrounds/settings/privacy_header_desktop.jpg';
      }
    });
  }

  ngOnInit() {
    this.title.setTitle('Bruce\'s | Use of cookies');
  }

}
